import React from 'react';
import {Button} from '../../kit-components/Button';
import { InfoList} from '../../kit-components/InfoList';
import styles from './payment-summary.module.scss';

export default function PaymentSummaryStep(props) {
  const { installmentSummary, handleConfirmInstallment } = props;
  const handleSubmit = () => {
    handleConfirmInstallment();
  };

  return (
    <>
      <InfoList
        title="Transaction summary"
        list={[
          {
            key: 'Down payment',
            value: installmentSummary.downpayment,
          },
          {
            key: 'Installment plan',
            value: `${installmentSummary.month} months/EGP ${installmentSummary.installment} monthly`,
          },
          {
            key: 'Financed amount',
            value: `${(parseInt(installmentSummary.amount)/100) - parseInt(installmentSummary.downpayment)}`,
          },
          {
            key: 'Admin Fees',
            value: installmentSummary.adminFees,
          },
        ]}
      />
      <div className={styles['actions']}>
        <Button label="Proceed" onClick={handleSubmit} />
      </div>
    </>
  );
}
